import CustomInput from 'components/common/CustomInput'
import CustomSelect, { ISelectOption } from 'components/common/CustomSelect'
import { statusSelect } from 'data/quote'
import { useEffect, useState } from 'react'
import CountryData from 'data/country.json'
import { IListSearch, ISearchInfo } from 'types/quote'
import { ReactComponent as Reset } from 'assets/common/reset.svg'
import { formatDate } from 'components/function'
import CustomDatePicker from 'components/common/CustomDatePicker'

const First = ({ searchInfo, setSearchInfo, init }: IListSearch) => {
    const [option, setOption] = useState<ISelectOption[]>([])
    const [dateReset, setDateReset] = useState<boolean>(false)
    useEffect(() => {
        const mapped: ISelectOption[] = CountryData.map(item => ({
            value: item.id || '',
            label: item.ko,
            labelEn: item.en
        }));

        setOption(mapped);
    }, [])

    const reset = () => {
        setSearchInfo({
            page: 1,
            pageSize: 10
        } as ISearchInfo);
        setDateReset(true)
    }

    return (
        <>
            <p className='font-semibold tablet:text-xl text-3xl'>견적 현황</p>

            <div className='bg-white rounded-lg'>
                <div className='flex items-center px-10 tablet:px-4 border-b-1 w-full h-20'>
                    <p className='font-semibold text-2xl'>검색 </p>
                </div>
                <div className='flex tablet:flex-col gap-6 tablet:p-4 px-10 py-6'>
                    <div className='w-[320px] tablet:w-full'>
                        <CustomInput
                            type="text" height={15} fontSize={'sm'} placeholder="검색어를 입력해주세요"
                            value={searchInfo.title ?? ''}
                            onChange={(e) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    title: e.target.value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    <div>
                        {/* 견적수락일 */}
                        <div className='flex items-center gap-1 bg-[#F8F8FA] rounded'>
                            <CustomDatePicker
                                onChange={(value: Date | null | [Date | null, Date | null]) => {
                                    if (Array.isArray(value) && value.every(v => v !== null)) {
                                        const [start, end] = value;
                                        setSearchInfo(p => ({
                                            ...p,
                                            fromDate: formatDate(start),
                                            toDate: formatDate(end),
                                            page: 1
                                        }))
                                    }
                                    else if (Array.isArray(value) && value.every(v => v === null)) {
                                        reset()
                                    }
                                }}
                                isRange={true}
                                isMaxToday={true}
                                isReset={dateReset}
                                setIsReset={setDateReset}
                            />
                        </div>
                    </div>

                    <div className='w-[180px]'>
                        <CustomSelect
                            height={60}
                            fontSize={14}
                            option={statusSelect}
                            value={
                                searchInfo.status
                                    ? statusSelect.find(arr => arr.value === searchInfo.status)
                                    : null
                            }
                            placeholder={'상태선택'}
                            onChange={(value) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    status: value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    <div className='w-[180px]'>
                        <CustomSelect
                            height={60}
                            fontSize={14}
                            option={option}
                            value={
                                searchInfo.origin
                                    ? option.find(arr => arr.value === searchInfo.origin)
                                    : null
                            }
                            placeholder={'출발국가'}
                            onChange={(value) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    origin: value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    <div className='w-[180px]'>
                        <CustomSelect
                            height={60}
                            fontSize={14}
                            option={option}
                            value={
                                searchInfo.destination
                                    ? option.find(arr => arr.value === searchInfo.destination)
                                    : null
                            }
                            placeholder={'도착국가'}
                            onChange={(value) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    destination: value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    {
                        Object.entries(searchInfo)
                            .filter(([key]) => key !== 'page' && key !== 'pageSize') // page 제외
                            .some(([, value]) => value !== '' && value !== null) && (
                            <div
                                className='group flex justify-center items-center border rounded-md w-15 h-15 overflow-hidden cursor-pointer'
                                onClick={reset}
                            >
                                <Reset className='group-hover:scale-120 transition-all' />
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default First